var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 567 190",
    style: {
      enableBackground: "new 0 0 567 190"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000041996502522056464930000003284987203831446420_);fill:#FFF200;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -135,
    y: -26.3,
    width: 841.9,
    height: 595.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130628857933381331640000010736934294377905818_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M330.5,16.8 c-9,2.8-18.9,4.8-28.2,7.3c5.9,2.9,12.4,5.3,18.5,8.1c-9.2-0.6-18.1-1.8-27.7-2.9c-3.1-0.3-6.4-1.2-9.2-1c-2.1,0.2-4.4,0.9-6.5,1.4 c-6.2,1.5-12.9,3.3-19.3,4.6c-0.2-0.7,0.7-1.4,1.3-2.1c1.6-1.9,3.7-4.1,5.3-6.2c-3.9-0.6-8.1-0.9-12.1-1.4c-4-0.5-8-0.8-11.6-1.8 c6.7-0.5,14-0.9,21-1.4c2.2-0.2,5,0.1,6.9-0.5c1.1-0.3,2.9-2.5,3.8-3.5c1.6-1.7,2.7-3.6,4-4.1c3.5,1.3,7.4,3.1,11.2,4.6 c1.2,0.5,2.6,1.3,3.7,1.4c1.5,0.2,3.4-0.2,5.1-0.3C307.7,18.3,319.5,17.5,330.5,16.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M240.3,15.5 c-3.5,1.5-7.8,2.3-11.6,3.5c1.6,1.3,3.4,2.4,5.3,3.5c-4.3,0.6-8.9-1.3-13.2-1.1c-2,0.1-4.2,1.1-6.1,1.6c-2,0.6-3.9,1.2-5.7,1.8 c0.4-1.6,2.7-2.6,3.7-4.1c-3.1-0.6-6.5-0.9-9.7-1.3c1.8-0.7,4-0.6,6.1-0.8c2-0.2,4.5-0.1,6.2-0.6c2.1-0.7,2.9-3.2,4.6-4 c2.1,0.3,3.2,2.6,5.3,3c2.2,0.4,5.2-0.4,7.8-0.6C235.4,16,237.9,15.8,240.3,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M414.2,15.5 c0-0.1,0.1-0.1,0.2-0.2c43.8,8.9,85.3,19,116.7,40.8c4.9,3.4,9.5,7.9,13.4,12.9c3.8,5,7.1,11.5,6.4,19.8 c-0.5,6.6-4.3,13.1-8.3,17.7c-4.1,4.8-9.1,8.8-14,12.1c-26.1,17.6-60.3,27.5-95.5,35.4c-3.6,0.8-7.2,1.5-10.8,2.2 c-10.7,2.2-21.6,3.9-32.8,5.9c-3.8,0.7-7.8,0.8-11.6,1.4c-18.2,3-38.1,4.2-58.3,6.2c-7.9,0.8-16.2,1.1-24.5,1.4 c-24.5,1-51.6,2-76.4,1c-8.4-0.4-16.8-0.4-25-0.6c-24.8-0.8-49.1-2.9-72.7-5.6c-31.4-3.5-61.3-9.2-88.8-15.8 c3.2-0.2,6.4,0.8,9.6,1.3c9.7,1.5,19.6,3,29.6,4c13.3,1.3,26.8,3.3,40.6,4c14,0.7,28.2,1.6,42.7,2.4c14.6,0.8,29.7,0.5,44.8,0.5 c44.7,0,86.4-3.3,126.2-8c13.3-1.6,26.3-3.8,38.7-6.2c12.4-2.4,24.8-4.9,37-7.8c23.9-5.7,46.6-13.3,66.6-23.8 c10-5.2,19.5-11.1,26.5-18.8c3.4-3.8,7-8.7,8.6-14.2c1.8-6.4,0.9-13.2-1.8-18.6c-5-10.2-13.2-16.7-22.5-22.8 c-9.2-6-19.6-10.9-30.1-15.1c-5.4-2.2-10.9-4.2-16.6-6.1C426.2,19,420.2,17.3,414.2,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M213.6,27 c-3.7,1.6-8.2,2.3-12.1,3.7c1.4,1.8,3.5,2.9,4.8,4.8c-2.2-0.5-4.3-0.7-6.5-1.1c-2.1-0.4-4.4-1.3-6.4-1.3c-2,0-4.1,1.2-6.1,1.8 c-2.1,0.6-4.1,1-6.1,1.8c0.5-1.8,3-3.1,4.1-4.8c-2.9-0.9-6.5-1.2-9.6-1.9c2.4-0.4,4.8-0.6,7.6-0.8c1.8-0.1,3.8,0.1,5.1-0.3 c1.2-0.4,3.8-3.6,5.1-4.5c1.5,0.2,3.2,3.3,4.8,3.7c0.6,0.2,1.3-0.1,1.9-0.2C204.4,27.5,209.5,27.3,213.6,27"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M162,33.5 c3.2-0.3,6.6-0.4,10-0.5c-2.7,1.2-6,1.7-8.9,2.7c0.6,1.2,1,2.6,1.8,3.7c-2.8,0.2-5-1.8-7.8-1.9c-2.9-0.1-6.4,2.3-9.4,2.6 c1.2-1.4,2.9-2.4,4.3-3.7c-1.7-0.9-4-1.2-5.9-1.9c3-1,6.4,0.1,9.1-0.8c2-0.7,3-2.7,4.6-3.5C160.8,30.9,161.1,32.5,162,33.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M340.7,30.9 c7.7,2.8,17.1,6.2,25.7,9.4c2.8,1.1,6,2.8,8.4,3.2c3.2,0.5,7.2,0,10.8,0c24.7,0,50.2-0.2,74.9-0.3c-4.6,1.5-9.6,2-14.5,2.9 c-14.5,2.6-29.3,5.2-43.8,7.8c17.9,7.5,36.7,14,54.5,21.5c-27.5-4.6-55.6-9.9-83.5-14.5c-1.9-0.3-3.8-0.9-5.4-1 c-1.9,0-4.1,0.6-6.2,1c-13.8,2.3-28.3,4.9-42.2,7.3c-0.2-1.1,0.9-2.6,1.6-3.8c2-3.7,4.5-7.8,6.4-11.6c-15.5-2.8-31.1-5.5-46.5-8.3 C294.3,44,310.9,44,326,44c2,0,5.1,0.3,6.4-0.2c1.3-0.5,3.2-4.8,4-6.2C338,34.9,339.4,33,340.7,30.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M262.2,38.6 c-7.5,2.3-15.8,3.8-23.6,5.9c3,3.2,7.6,6.1,10.8,9.6c-6.4-1.5-12.8-3.1-19.3-4.6c-2.1-0.5-4.4-1.4-6.4-1.4 c-1.7-0.1-3.8,0.7-5.7,1.1c-5.4,1.2-10.8,2.6-16.3,3.8c2.4-2.9,5.3-5.5,7.8-8.3c-5.7-1.5-11.6-2.8-17.4-4.3c6.8-1,14.8,0,21.4-0.6 c2.1-0.2,3.3-2.1,4.9-3.7c1.7-1.6,3-2.7,4.3-4c3.1,2.3,6,4.8,9.1,7.2C242.3,39,252,39,262.2,38.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M133.3,38 c0.2,1.1,0.6,2,0.8,3c2.4,0.1,5.7-0.1,8.4-0.2c-2.3,1.2-5.4,1.5-7.8,2.5c0.4,1.2,0.8,2.4,1,3.8c-2.2-0.3-3.9-2.1-6.1-2.2 c-2.6-0.1-5,1.9-7.7,2.2c-0.1-0.8,1.1-1.2,1.8-1.8c0.7-0.6,1.4-1.3,2.1-1.8c-1.5-0.8-3.2-1.3-4.8-1.9c2.6-0.8,5.1,0.2,7.5-0.5 C130.5,40.8,131.4,38.3,133.3,38"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M178.2,45.1h17.1 c-4.5,1.4-9.4,2.5-14.2,3.7c1,2.5,2.8,4.3,4,6.7c-2.2-0.6-4.4-1.2-6.7-1.9c-2.1-0.6-4.4-2-6.5-2.1c-2.1-0.1-4.6,1-6.9,1.6 c-2.3,0.6-4.5,1.1-6.7,1.8c0.3-1.2,1.6-2.1,2.5-3c1-1,2.3-1.8,3-2.9c-2.9-1.4-6.8-1.9-9.6-3.5c2.5-0.1,4.8,0.1,7,0 c2.1-0.1,4.6,0.3,6.5-0.2c1.7-0.4,5-4.7,6.5-5.6C175.9,41.3,177.1,43.2,178.2,45.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M111.9,42.4 c0.6,0.6,0.3,1.9,0.5,2.9c2.1,0.1,3.9-0.2,5.9-0.2c-1.5,1.1-3.8,1.3-5.6,2.1c0.1,1,0.1,2.1,0.3,3c-1.8,0-2.8-1.5-4.5-1.6 c-2.1-0.1-3.9,1.6-6.1,1.8c0.9-1.1,2.2-1.9,3.2-2.9c-0.7-1-2.6-0.8-3.2-1.9c2.2-0.2,4,0.3,5.6-0.2C109.8,45,110.6,43.1,111.9,42.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M139.5,51 c2.9-0.3,7-0.3,9.9,0c-2.5,1.3-5.8,1.9-8.6,2.9c0.3,1.8,1.1,3,1.4,4.8c-2.8-0.3-5-2.8-7.8-2.9c-2.9-0.1-5.6,2.1-8.6,2.6 c0.5-1.7,3-2.9,4.1-4.5c-1.8-1-4.1-1.7-6.1-2.5c3.1-0.9,6.1,0.4,8.9-0.3c2.1-0.5,3.1-3.3,4.8-4.1C138.6,47.9,138.8,49.7,139.5,51"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M94.7,48.5 c0.6,0.2-0.4,1.4-0.2,2.2c1.3,0.3,3.1,0.1,4.5,0.3c-1.3,0.7-3.1,1-4.8,1.4c-0.5,0.8-0.7,1.9-1,3c-1.1-0.4-1.8-1.2-2.7-1.8 c-1.9,0.2-3.2,1-5.1,1.1c1-0.9,2.3-1.5,3.3-2.4c-0.4-0.8-2.1-1.1-1.9-1.9c1.6,0,3,0.5,4.3,0.2C92.6,50.4,93.5,48.8,94.7,48.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M308.2,61.7 c-8,1.8-16.6,3-25,4.5c4,3.9,9.4,7.4,13.2,11c-7.1-1.9-14.4-4.1-21.8-6.2c-2.4-0.7-5-1.9-7.2-2.1c-1.7-0.1-3.9,0.5-5.9,0.8 c-5.6,0.9-11.4,1.9-17.2,2.9c2.3-3,5-5.4,7.3-8.3c-6.4-2.2-13.5-3.8-19.6-6.2c6.7,0.4,14.7,0.7,21.2,1c0.9,0,2.1,0.4,3,0.2 c1-0.3,2.9-2.5,3.8-3.5c1.6-1.6,2.8-2.9,3.8-4.1c4,2.7,7.5,5.9,11.5,8.6C286.3,60.6,297.2,61.2,308.2,61.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M112.4,51.7 c0.8,0.6,0.4,2.4,1,3.3h6.5c-1.9,0.9-4.2,1.4-6.4,2.1c0.2,1.2,0.3,2.4,0.5,3.7c-1.9-0.1-3-1.9-4.8-2.1c-2.1-0.2-4,1.6-6.4,1.8 c0.9-1.2,2.3-2.1,3.3-3.2c-1-1.1-2.8-1.2-3.7-2.4c2.4-0.4,4.4,0.5,6.2,0C110.4,54.4,111.2,52.4,112.4,51.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M81.2,53.3 c0.4,0.7-0.4,1.6-0.5,2.4c0.8,0.5,2.5,0.2,3.5,0.5c-1.1,0.7-2.7,0.9-4.1,1.3c-0.6,0.7-0.8,1.9-1.3,2.7c-0.7-0.6-1.3-1.2-1.9-1.9 c-1.3,0.4-2.8,0.8-4.1,1.1c0.7-0.9,1.8-1.5,2.9-2.1c-0.2-0.9-1.2-1-1.4-1.9C77.6,55.9,79.5,54.8,81.2,53.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M196.4,61.4 c5.9,0.2,11.2,0.9,17.1,1.1c-2,1-4.5,1.3-6.9,1.8c-2.5,0.5-4.9,0.9-7.3,1.3c0.6,2.5,2.8,4.8,3.8,7.5c-3.4-1.2-6.7-2.7-10.2-4.1 c-1.1-0.4-2.4-1.2-3.3-1.3c-2.1-0.2-4.6,0.9-6.9,1.3c-2.3,0.4-4.6,0.8-7,1.1c1.8-2.1,4.2-3.6,6.1-5.6c-3-1.8-6.9-2.7-9.9-4.6 c3.9,0.4,7.4,0.4,11.3,0.6c0.9,0,1.9,0.5,2.6,0.3c0.9-0.2,2.4-1.7,3.3-2.5c1.3-1.2,2.3-2.2,3.3-3C194,57,195.1,59.3,196.4,61.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M91.4,57.7 c0.5,0.3-0.1,2.1-0.2,2.9c1.4,0.2,3.1,0.2,4.6,0.3c-1.2,1-3.3,1.1-4.9,1.6c0,1.3-0.3,2.2-0.5,3.3c-1.1-0.7-2-1.5-3-2.2 c-1.7,0.5-3.3,1.1-5.1,1.4c0.9-1.2,2.3-1.7,3.2-2.9c-0.7-0.8-1.7-1.2-2.2-2.1c1.7,0,3.2,0.6,4.5,0.3C89.3,60.1,90.2,58.3,91.4,57.7 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M150.2,62.3 c3.4,0.3,7,0.4,10.5,0.6c-2.7,1.3-6.1,1.7-9.1,2.7c0.6,1.7,1.2,3.4,1.9,4.9c-2.9,0.1-5-2.9-8-3.2c-3-0.3-5.8,1.9-9.1,2.1 c1.1-1.8,2.9-2.9,4.1-4.5c-1.9-1.1-4.1-1.9-6.1-3c3.2-0.8,6.1,0.7,8.8,0.2c2.2-0.4,3-3.3,4.8-4.1C149.1,59.1,149.5,60.9,150.2,62.3 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M68.6,58.5 c0.7,0.3-0.5,1.1-0.5,1.8c0.4,0.5,1.7,0.3,2.2,0.6c-0.8,0.5-2,0.6-3,0.8c-0.8,0.5-0.6,1.9-1.6,2.2c-0.1-0.7-0.6-1.1-1-1.6 c-0.9,0.3-2,0.5-2.9,0.8c0.4-1,1.6-1.1,2.2-1.8c-0.1-0.7-0.6-0.9-0.6-1.6C65.7,60.6,67.4,59.7,68.6,58.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M119.6,61.4 c0.6,0.6,0.4,1.9,0.5,3c1.8,0.4,4.2,0.3,6.1,0.6c-1.7,0.9-4.1,1-5.9,1.8c-0.1,1.3,0.3,2.1,0.2,3.3c-1.7-0.5-2.7-1.7-4.1-2.4 c-2,0.5-3.9,1.1-6.1,1.4c1.1-1,2.3-1.9,3.5-2.9c-0.8-1.1-2.5-1.3-3.2-2.6c2,0,3.8,0.8,5.4,0.5C117.6,63.9,118.4,62.1,119.6,61.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M76.4,61.7 c0.6,0.1-0.3,1.3-0.2,1.9c0.8,0.3,1.8,0.3,2.9,0.3c-0.6,0.9-2.2,0.8-3.2,1.3c-0.4,0.6-0.6,1.3-0.6,2.2c-1-0.1-1.1-1-1.9-1.3 c-1.2,0.1-2.2,0.5-3.2,1c0.5-1.5,3.4-2.1,0.6-3.5C73.3,63.7,75.3,63.3,76.4,61.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M57.9,63.5 c0.7,0.1-0.1,1-0.2,1.3c0.4,0.3,0.9,0.3,1.6,0.3c-1,0.9-2.8,0.8-3,2.4c-0.6,0-0.5-0.8-1-1c-0.7,0-1.4,0.6-1.9,0.3 c0.4-0.5,1-0.7,1.4-1.1c-0.1-0.4-0.5-0.7-0.5-1.3C55.9,65.1,57.2,64.5,57.9,63.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M100.5,63.5 c0.7,0.1,0.2,1.5,0.2,1.9c1.1,0.3,2.5,0.3,3.7,0.5c-0.9,0.8-2.5,0.8-3.7,1.3v2.2c-1.2-0.2-1.7-1.1-2.7-1.6 c-1.2,0.4-2.4,0.8-3.7,1.1c0.5-0.9,1.5-1.3,2.1-2.1c-0.3-0.9-1.5-0.7-1.6-1.8C97.5,65.8,99.2,64.9,100.5,63.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M65.7,64.6 c0,0.7-0.5,0.9-0.5,1.6c0.4,0.4,1.8-0.1,2.2,0.3c-1.5,0.7-3.5,1-3.7,3c-0.6-0.3-0.8-0.9-1.3-1.3c-1-0.1-2,0.7-2.6,0.5 c0.4-0.7,1.2-0.9,1.8-1.4c-0.1-0.7-0.7-0.8-0.8-1.4C63.3,66.5,64.4,65.4,65.7,64.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M88,65.9 c0.5,0.4-0.2,1,0,1.6c0.7,0.3,1.7,0.2,2.5,0.3c-0.7,0.5-1.8,0.6-2.7,1c-0.2,0.4-0.2,1.1-0.2,1.8c-0.9-0.1-1-0.9-1.8-1.1 c-1.1,0-1.7,0.6-2.7,0.6c0.3-0.6,0.9-0.9,1.4-1.3c0-0.7-1.2-1-1-1.4C85.9,67.6,87.1,66.8,88,65.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M50.7,67.3 c0.2,0.4-0.4,0.9,0.2,1.4c-0.9,0-1.2,0.5-1.4,1.1c-0.6-0.2-0.8-1-1.4-0.3c-0.3-0.6,1.1-0.6,0.5-1.8C49.3,68.2,50.4,67.8,50.7,67.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M76.6,67.8 c1.2,0.5,1.8,0.3,3,0c-0.1,0.4-0.5,0.6-0.6,1c0,0.6,1,0.2,1,0.8c-1.7-0.3-2.3,0.5-3,1.1c0-0.4,0.1-0.9-0.2-1.1 c-0.4,0.1-1,0.3-1.3,0c0.1-0.4,0.6-0.4,1.1-0.5V67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M68.4,68.7 c0,0.7,0.1,1.1,0.8,1.4c-1.1-0.2-1.3,0.5-1.4,1.3c-0.4-0.5-1-0.8-1.9-0.5c0.5-0.5,0.8-0.7,0.3-1.4C67.3,69.6,68.1,69.4,68.4,68.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M55.7,68.9 c0.6,0.2-0.2,1.3,1,1.1c-0.7,0.5-1.8,0.6-1.8,1.8c-0.5-0.1-0.5-0.5-0.8-0.8c-0.5,0-0.7,0.4-1.3,0.3c0.6-0.5,1-0.8,0.5-1.8 C54.2,70,55.3,69.5,55.7,68.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M59.8,70.8 c0.4,0.1,0.3,0.7,1,0.5c0,0.7-1.2,0.3-1,1.3c-0.6,0.2-0.8-0.7-1.3-0.2c-0.2-0.3,0.1-0.7-0.3-1.1C58.9,71.3,59.6,71.3,59.8,70.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M49.1,71.4 c0.5,0.1,0.1,0.6,0,1h1.1c-0.1,0.5-0.7,0.5-1.3,0.6c-0.1,0.4-0.3,0.6-0.3,1.1c-0.7-0.4-1.4-0.7-2.2-0.2c-0.1-0.6,0.7-0.4,0.8-1 c-0.1-0.3-0.6-0.1-0.5-0.6C48.1,72.6,48.5,72,49.1,71.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M42.9,71.6 c0.4,0.4,0.8,0,1.3,0c-0.1,0.3,0.1,0.3,0.3,0.3c-0.2,0.4-0.9,0.3-1,1c-0.3,0-0.2-0.4-0.6-0.3V71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M52.6,74.1 c-0.5,0.5,0.3,0.5,0.3,1c-1-0.2-0.8,0.9-1.6,1c0-0.4-0.2-0.5-0.6-0.5c0.1-0.6,0.2-0.8,0-1.3C51.4,74.7,52,74.3,52.6,74.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M43.4,74.5 c0.2,0.4-0.1,1,0.8,1c-0.6,0.5-1.6,0.5-1.8,1.4c-0.4-0.5-0.5-0.7-1.4-0.5c0.3-0.5,0.8-0.6,0.5-1.4C42.3,75,43.1,75,43.4,74.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M47.7,75.4 c0,0.1-0.2,0.2-0.2,0.3c0.1,0.2,0.2,0.3,0.5,0.3c-0.5,0.3-1.2,0.3-1.3,1c-0.6-0.4-0.4-0.7-0.6-1.3C46.6,75.6,47.1,75.7,47.7,75.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M98.5,81 c-1.5,2.9-3.1,5.7-4.9,8.3H53.8c-1.3,1.4-2.2,3.2-3,5.1h16.4c5.5,0,11.3-0.7,16.4,0c1.8,0.3,4.2,1.4,4.5,3c0.3,1.8-1.3,4-2.1,5.3 c-1.9,3.2-3.6,5.7-5.4,8.9c-0.9,1.6-1.6,3.4-2.7,4.5c-2,2-5.8,3.8-9.6,4.1c-3.7,0.4-7.9,0-11.8,0H21.4c1.4-3,3.1-5.6,4.8-8.3H66 c2.1-2.8,3.8-6,5.6-9.2c-6.1,0-13.3,0-20.4,0c-5.7,0-16.5,1.3-16.9-3.7c-0.2-2.2,2.5-5.3,3.5-7c1.4-2.4,2.4-5,4.3-6.9 c6.1-5.9,21.3-4.1,33.5-4.1H98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M103.3,81h54 c-1.1,2.6-3.2,5.7-4.8,8.3h-19c-6.4,10.1-12.1,20.8-18.5,30.9h-13.9c5.7-10.5,12-20.4,17.9-30.8c-6.6-0.4-13.9-0.1-20.7-0.2 C100,86.5,101.5,83.6,103.3,81"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M172.7,92.5 c-3.9,3.7-8.6,6.7-12.4,10.5h13.4C173.3,99.5,173.6,95.4,172.7,92.5 M188.4,81c0.9,12.9,1.5,26.7,2.4,39.1 c-5.1,0.4-10.9,0.1-16.3,0.2c0-3.1-0.4-5.9-0.5-8.9h-18.2c-2,0-4.4-0.4-6.1,0c-1.4,0.4-4.4,3.4-5.7,4.5c-0.8,0.6-1.7,1.6-2.7,2.4 c-0.7,0.6-2.1,1.9-2.9,2.1c-2.4,0.6-5.5,0-8,0h-7.8c15.9-13.3,32.1-26.2,48.1-39.2H188.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M221.9,94.4h25.8 c0.8-1.8,2.1-3.1,2.7-5.1h-25.7C223.7,90.8,222.6,92.4,221.9,94.4 M215.5,81c14.1,0.7,31.8-1,45.6,0c2.6,0.2,5.5,1.1,5.7,3.3 c0.2,1.8-1.2,3.6-2.1,5.1c-2.6,4.6-5.5,8-11.5,8.9c1.5,0.8,3.3,1.2,3.5,3c0.2,1.8-1.3,3.5-2.2,5.1c-2.5,4.3-5.8,10.2-8,13.7h-14 c3.2-5.9,6.8-11.5,10-17.4c-8.2-0.4-17.2-0.1-25.7-0.2c-3.9,5.5-6.9,11.9-10.7,17.5h-13.9C200,107,207.6,93.9,215.5,81"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M270.4,111.9h25.8 c4.4-7.5,9-14.9,13.2-22.6h-25.8C279.1,96.7,274.6,104.2,270.4,111.9 M274.4,81h40.8c4.1,0,9.7-0.2,10.5,3c0.6,2.4-2.6,6.4-3.7,8.3 c-3.2,5.6-5.9,10-9.1,15.5c-1.5,2.6-2.9,5.6-4.6,7.7c-5.4,6.7-20.9,4.8-33.5,4.8h-23.3c-0.2-0.9,0.6-1.7,1-2.4 C259.5,105.9,267.2,93,274.4,81"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M333.3,81h14 c-5.8,10.5-12.2,20.4-18,30.9h25.5c6.5-10,12.2-20.9,18.6-30.9h13.9c-4.9,8.6-10,17.3-15.1,26c-1.6,2.8-3.2,6.1-5.1,8.4 c-1.7,2.1-6.2,4.4-10.2,4.8c-5.8,0.5-13.1,0-19.8,0h-9.9c-5.3,0-14.1,1.1-14.5-3.5c-0.1-1.3,1.2-3.5,2.1-4.9 c4.3-7.3,8.7-14.5,12.9-21.7C329.6,87,331.3,83.8,333.3,81"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M392.2,81h54 c-1.2,3-3.2,5.2-4.5,8.1c-15.6,7.5-31.3,15-46.7,22.8h33c-1.3,3-3.1,5.6-4.8,8.3H369c1.4-2.8,3.1-5.3,4.6-8 c15.5-7.7,31.2-15.1,46.7-22.8c-10.6-0.4-21.9-0.1-32.8-0.2c-0.1-1.1,1.1-2.5,1.9-3.8C390.4,83.9,391.1,82.3,392.2,81"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M63.6,125.3 c-0.6,1.4-1.6,2.3-2.5,3.3H44.4c-1.9,0-4.3-0.4-5.6,0c-1,0.3-1.5,1.7-2.1,2.4H48c3.7,0,7.8-0.7,9.9,1.3c-0.4,1.9-1.9,2.9-3,4.3 c-2,2.5-3.5,4.9-8,5.3c-7.6,0.7-17.8-0.5-25.8,0c-0.3-0.9,1.5-2.4,2.2-3.3h16.9c1.9,0,4.3,0.4,5.6,0c1.6-0.5,2.1-3.2,3.3-4.1 c-5.1-0.2-11.1-0.2-17.1-0.2c-1.4,0-3.7,0-4-1.1c-0.3-1.2,3.6-5.7,4.6-6.4c1.3-0.8,3.4-1.3,5.3-1.4 C45.8,124.7,56.1,125.8,63.6,125.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M71.9,128.7 c-0.6,0.8-1.4,1.4-1.8,2.4h15c0.7-0.7,1.4-1.3,1.8-2.4H71.9z M67.8,134.2c-2.4,2.2-4.1,5.3-6.4,7.7h-7.2c4-5.7,8.4-11.1,12.8-16.4 c6.3,0.3,19-0.9,25.8-0.2c1.1,0.1,2.7,0.7,2.9,1.3c0.3,1-1.5,2.6-1.9,3.2c-1,1.3-1.5,2.3-2.2,2.9C86.7,136.3,75.5,133.2,67.8,134.2 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M97.6,138.5h15.1 c2.5-3.3,5.3-6.3,7.5-9.9h-15C102.7,131.9,100,135.1,97.6,138.5 M89,140.8c0-1.7,1.5-2.8,2.4-4c0.9-1.1,1.8-2.3,2.7-3.5 c2.7-3.4,4.5-7.5,10.4-8c3.8-0.3,8.5,0,12.9,0c3.4,0,10.9-0.7,11.6,1.1c0.6,1.3-4.2,6.3-4.9,7.3c-2.6,3.4-4.7,7.6-10.4,8.1 c-3.8,0.3-8.5,0-12.9,0C96.3,141.9,91.6,142.6,89,140.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M138.7,128.7 c-0.6,0.8-1.3,1.4-1.8,2.4h15c0.7-0.7,1.4-1.4,1.8-2.4H138.7z M154.5,132.6c0.8,0.4,1.9,0.4,2.2,1.3c-1,3-3.8,5.4-5.7,8h-7.2 c1.5-2.8,3.9-4.7,5.4-7.5c-4.6-0.3-10.3-0.3-14.8,0c-2.4,2.2-4,5.2-6.2,7.5H121c3.8-5,7.9-10.9,12.4-16.3c0.6-0.7,4.7-0.3,7-0.3 c6,0,13.3-0.4,18.6,0c1.4,0.1,3.2,0.5,3.3,1.3c0.3,1-1.9,3.5-2.6,4.1C158.4,132.1,156.4,132.2,154.5,132.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M197.4,125.3 c-0.7,1.3-1.6,2.3-2.6,3.3c-3.8,0.7-7.5-0.9-10.5,0c-0.8,0.2-2.2,2.3-2.9,3.2c-2.6,3.4-5.3,7.1-7.8,10h-7.3 c3.1-4.6,6.9-8.6,10-13.2h-11.6c0.7-1.1,1.8-2.7,2.7-3.2C177,125.1,188.1,125.4,197.4,125.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M230.7,125.3 c-0.6,1.3-1.6,2.4-2.5,3.3h-16.9c-1.9,0-4.3-0.4-5.6,0c-0.9,0.3-1.4,1.7-1.9,2.4h11.2c3.6,0,7.7-0.6,9.9,1.1 c-0.2,1.9-1.7,3-2.7,4.3c-2,2.6-3.6,5.1-8.3,5.4c-7.7,0.6-18.1-0.4-26,0c0.6-1.4,1.6-2.3,2.6-3.3h22.5c1.2-1.3,2.3-2.6,3.2-4.1 c-3.2-0.3-7.3-0.2-11.2-0.2c-3.7,0-7.9,0.8-9.9-1.3c2-3.7,4.3-7.2,9.7-7.7C212.2,124.6,223.1,125.8,230.7,125.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M274,125.3 c-0.2,1.1-1.6,2.4-2.4,3.3h-15c-1.6,0-3.7-0.4-4.9,0c-1.2,0.4-3.1,3.7-4,4.8c-1.4,1.7-2.6,3.3-3.8,4.9c6.2,0.4,13.1,0.1,19.6,0.2 c0.3,0.9-1.5,2.4-2.2,3.3c-7.4-0.7-16.6,0.9-23.6,0c-0.9-0.1-2-0.5-2.5-1.3c1.1-2.7,3.1-4.6,4.8-6.9c0.8-1,1.7-2.2,2.6-3.3 c2.1-2.7,3.9-4.7,8.3-5.1C257.8,124.6,266.5,125.8,274,125.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M284.7,125.3 c-2.7,4.4-6.8,8.8-10,13.2h20.1c-0.7,1.3-1.6,2.3-2.6,3.3h-12c-4.1,0-8.4,0.6-12,0c-4.1-0.7-1.1-3.4,0.3-5.3c3-3.8,5.7-7.4,8.6-11 c0.1-0.1,0.3-0.2,0.5-0.3H284.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M315.6,125.3 c-3.1,4.7-6.8,8.7-10,13.2h7.5c2.4,0,5.3,0.6,7.3,0c0.8-0.3,2.1-2.2,2.9-3.2c2.7-3.4,5.3-7,8-10h7c-1.4,2.4-3.3,4.8-5.3,7.3 c-0.9,1.1-1.9,2.3-2.9,3.5c-2.2,2.8-3.6,5.4-8.8,5.7c-3.3,0.2-7.3,0-11,0c-3.8,0-7.9,0.4-11,0c-4.2-0.6-1.6-3.2,0-5.3 c3-3.8,5.9-7.4,8.8-11.2C310.3,125.1,313.7,125.4,315.6,125.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130628857933381331640000010736934294377905818_)",
      fill: "#FFF200"
    },
    d: "M339.1,138.5h15 c1.2-1.3,2.5-2.5,3.2-4.3h-14.8C341.2,135.5,340,136.9,339.1,138.5 M346.7,128.7c-0.6,0.8-1.4,1.4-1.8,2.4h15 c0.7-0.7,1.4-1.4,1.8-2.4H346.7z M341.9,125.3c3.8,0,8.3,0,12.9,0c4.5,0,9.3-0.5,13.1,0c1,0.1,1.9,0.5,2.6,1.3 c-1.2,3.5-3.7,5.6-8,6.1c3.7,0.5,1.6,2.9,0.2,4.8c-1.9,2.5-3.5,4.1-7.7,4.5c-7.8,0.7-19.2-0.5-26,0 C333.1,136.1,337.5,130.7,341.9,125.3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6988a465e038a87cc93215ef75e018cc.svg";
export { ForwardRef as ReactComponent };